const Index = () => import('@/views/package/index.vue')
const Upload = () => import('@/views/package/upload.vue')
const Detail = () => import('@/views/package/detail.vue')

export default [
  {
    path: '/packages',
    name: 'packages-index',
    component: Index,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/packages/upload',
    name: 'package-upload',
    component: Upload,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/packages/:packageId',
    name: 'package-detail',
    component: Detail,
    meta: {
      authenticated: true
    }
  }
]
